import { render, staticRenderFns } from "./userbind.vue?vue&type=template&id=05432155&scoped=true"
import script from "./userbind.vue?vue&type=script&lang=js"
export * from "./userbind.vue?vue&type=script&lang=js"
import style0 from "./userbind.vue?vue&type=style&index=0&id=05432155&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05432155",
  null
  
)

export default component.exports